module.exports = __webpack_public_path__ + "static/img/banner.3a0fc96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/banner.jpg
// module id = i7Ff
// module chunks = 1